import React from "react";
import Dialog from "Components/Core/Dialog";
import DialogPreview from './DialogPreview';
import DialogSelectText from "Components/Core/Form/DialogSelectText";
import DialogTable from 'Components/Core/DialogTable';
import Form from "Components/Core/Form/Form";
import FormElement from "Components/Core/Form/FormElement";
import FormSelectImage from "Components/Core/Form/FormSelectImage";
import './NewPosting.css';


export default function NewPosting(props) {

	const x = props.x;

	const memberRef = React.useRef(null);

	// "all" ist kein echtes Mitglied, sondern ein Schluesselwort fuer eine
	// Erwaehnung an alle Mitglieder (siehe SaveNewPosting.inc). Wird deshalb
	// nur hier fuer die @-Auswahlliste ergaenzt, nicht in x.wau.setMembersData
	// selbst, da diese Funktion auch anderswo (PostingMember.js) verwendet wird.
	function getMentionMembersData() {
		return [{ id: 'all', name: 'all' }, ...x.wau.setMembersData()];
	}
	const fileInputRef = React.useRef(null);
	const pendingFile = React.useRef(null);
	const lastTypingSent = React.useRef(0);
	// Analog zu NewThreadShort.js: null = kein aktiver ":"-Trigger, sonst der
	// Text nach dem zuletzt getippten ":".
	const [colonFilter, setColonFilter] = React.useState(null);

	function emitTyping() {
		const now = Date.now();
		if (now - lastTypingSent.current > 2000) {
			lastTypingSent.current = now;
			x.was.send('typing', { "memberid": x.was.memberId, "forumId": props.forumId });
		}
	}

	const wafId = props.dialogId;
	const dialogId = props.dialogId;
	const postingId = 'posting';
	const formId = props.dialogId + '-form';
	const previewId = wafId + '-preview';
	const resetId = wafId + '-reset';
	const smiliesId = props.dialogId + '-smilies';
	const selectMemberId = props.dialogId + '-select-member';
	const fileRenameId = props.dialogId + '-file-rename';

	React.useEffect(() => {
		// x.wau.postingRestore(wafId, props.answerTo);
	});

	x.wam.init(props.moduleId, {
		"onClose": () => {
			delete x.waf[wafId];
		}
	})

	React.useEffect(() => {
		x.waf.init(wafId, {
			"onAfterSend": onAfterSend,
			"onBeforeSend": onBeforeSend,
		});
		x.waf.init(fileRenameId);
		const handleKey = (event) => {
			if (event.key === '@' && x.wad[dialogId].isVisible && x.waf.isNewWord(wafId, postingId)) {
				memberRef.current.show();
				event.preventDefault();
			}
		}		
		
		window.addEventListener("keydown", handleKey);

		return () => {
			window.removeEventListener("keydown", handleKey);
		}

	});

	function onBeforeSend() {
		if (props.moduleId === 'forum' && props.answerTo === 0) {
			x.waf.setAddSend(wafId, 'topicid', props.topicId)
		}
		else {
			x.waf.setAddSend(wafId, 'topicid', 0)
		}
		// x.waf.set(wafId, postingId, x.wau.translatePosting(x.waf.get(wafId, postingId)));

		if (x.was.answerAsQuote && props.answerTo > 0) {
			// Statt einer Antwort im Thread wird ein neues Thema mit dem
			// zitierten Original-Beitrag erzeugt (siehe answer-as-quote).
			const original = x.wad[props.dialogId];
			const quote = x.wau.makeQuote(original.posting, original.postingDate, original.memberName);
			const currentText = x.waf.get(wafId, postingId);
			x.waf.set(wafId, postingId, quote + currentText);
			x.waf[wafId].addSend['answerto'] = 0;
		}
	}

	function onAfterSend(data) {
		if (data.returncode > 0) {
			x.was.send('new-posting', { "module": props.moduleId, "member": x.was.memberName, "memberlevel": x.was.memberLevel, "postingno": data.returncode });
			x.waf.set(wafId, postingId, '');
			x.wau.postingBackupRemove(wafId, props.answerTo);
			x.wam[props.moduleId].postings.load();
			if (x.was.memberLevel > 1) {
				clearPostingField();
			}
			else {
				setTimeout(() => { clearPostingField(); }, 200);
			}
			x.wad[props.dialogId].hide();
			if (props.moduleId === 'forum') {
				x.was.postingsUnread.forum = 0;
			}
			x.was.loadActiveMember();
		}
		else {
			x.wah.addHint('Fehler beim Speichern des Postings', true);
		}
	}

	function checkPaste(event) {
		let text = event.clipboardData.getData('text');
		if (x.wau.checkPaste(text, (props.answerTo === 0), () => { })) {
			event.preventDefault();
		}
	}



	function clearPostingField() {
		const shortWafId = x.was.chatMode ? 'new-thread-short-' + props.moduleId : 'new-thread-short-default';
		x.waf.set(shortWafId, 'new-posting-short', '');
	}

	function countSmileyMatches(filter) {
		// gleiche (nicht case-normalisierte) Logik wie makeSmilies(), damit "0 Treffer" hier
		// exakt dem entspricht, was makeSmilies() tatsaechlich anzeigen wuerde.
		if (filter.length === 0) return Object.keys(x.was.smilies).length;
		return Object.keys(x.was.smilies).filter((key) => key.includes(filter)).length;
	}

	// ":"-Trigger analog zu NewThreadShort.js::handleComposerChange - hier fuer
	// das "posting"-Feld der grossen Eingabemaske, die das bisher gar nicht
	// unterstuetzte. Fokus springt sofort ins Filter-Feld (wie beim Klick auf
	// das Smiley-Icon) - Escape schliesst den Dialog bei Bedarf wieder.
	function handleColonTrigger(value) {
		const inputEl = x.waf[wafId].elements[postingId].reference.current;
		const cursor = inputEl ? inputEl.selectionStart : value.length;
		const beforeCursor = value.substring(0, cursor);
		const lastColon = beforeCursor.lastIndexOf(':');
		let filter = null;
		if (lastColon !== -1) {
			const between = beforeCursor.substring(lastColon + 1);
			if (!/\s/.test(between)) {
				filter = between;
			}
		}
		if (filter !== null && countSmileyMatches(filter) > 0) {
			if (colonFilter === null) {
				x.waf[wafId].smileyTarget = postingId;
				x.waf[wafId][smiliesId].show({ preventDefault: () => {} }, true);
			}
			setColonFilter(filter);
		}
		else if (colonFilter !== null) {
			x.waf[wafId][smiliesId].hide();
			setColonFilter(null);
		}
	}

	function insertSmiley(event, key) {
		event.preventDefault();
		const target = x.waf[wafId].smileyTarget;
		const inputEl = x.waf[wafId].elements[target].reference.current;
		const curPos = inputEl.selectionStart;
		const curVal = x.waf.get(wafId, target);
		let leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		// Der ":"-Ausloeser wird HIER immer frisch direkt aus dem tatsaechlichen
		// Composer-Inhalt ermittelt, statt sich auf den colonFilter-React-State zu
		// verlassen: dieser kann durch die uebliche Verzoegerung zwischen einem
		// Tastatur-Event und dem anschliessenden Re-Render kurzzeitig noch null
		// (veraltet) sein, obwohl der Composer bereits ein ":" enthaelt.
		const lastColon = leftValue.lastIndexOf(':');
		const wasColonTriggered = lastColon !== -1 && !/\s/.test(leftValue.substring(lastColon + 1));
		if (wasColonTriggered) {
			let cut = lastColon;
			while (cut > 0 && leftValue[cut - 1] === ':') cut--;
			leftValue = leftValue.substring(0, cut);
		}
		const text = ':-' + key;
		x.waf.set(wafId, target, leftValue + text + rightValue);
		x.waf[wafId][smiliesId].hide();
		if (wasColonTriggered) {
			setColonFilter(null);
			inputEl.focus();
		}
	}

	function insertLink(wafId) {
		const dialogId = props.moduleId + '-add-link';
		x.wad[dialogId].wafId = wafId;
		x.wad[dialogId].show(() => { x.waf.focus(dialogId, 'url-title') });
	}

	function insertList(wafId) {
		const dialogId = props.moduleId + '-add-list';
		x.wad[dialogId].wafId = wafId;
		x.wad[dialogId].show(() => { x.waf.focus(dialogId, 'text') });
	}

	function selectFile() {
		fileInputRef.current.click();
	}

	function splitFileName(name) {
		const dotPos = name.lastIndexOf('.');
		if (dotPos <= 0) return { base: name, extension: '' };
		return { base: name.substring(0, dotPos), extension: name.substring(dotPos) };
	}

	function uploadFile(event) {
		const file = event.target.files[0];
		event.target.value = '';
		if (!file) return;

		pendingFile.current = file;
		x.waf.set(fileRenameId, 'filename', splitFileName(file.name).base);
		x.wad[fileRenameId].show(() => {
			x.waf.focus(fileRenameId, 'filename');
			x.waf.select(fileRenameId, 'filename');
		});
	}

	function confirmFileUpload(event) {
		event.preventDefault();
		const file = pendingFile.current;
		if (!file) return;

		const baseName = x.waf.get(fileRenameId, 'filename').trim();
		if (baseName === '') {
			x.wah.addHint('Bitte einen Dateinamen angeben.', true);
			return;
		}
		const fileName = baseName + splitFileName(file.name).extension;

		const formData = new FormData();
		formData.append('file', file, fileName);
		x.was.axPost('Backend/webapp.php?module=Posting&task=UploadFile', formData, (result) => {
			if (result.data.returncode === 1) {
				insertFileLink(result.data.content.fileName, result.data.content.displayName);
				x.wad[fileRenameId].hide();
			}
			else {
				x.wah.addHint(uploadErrorMessage(result.data.returncode), false);
			}
		});
		pendingFile.current = null;
	}

	// Ordnet die spezifischen Fehler-Returncodes von Backend/UploadFile.inc einer
	// verstaendlichen Meldung zu, statt immer nur "Fehler beim Hochladen der Datei" zu zeigen.
	function uploadErrorMessage(returncode) {
		switch (returncode) {
			case -2:
				return 'Datei ist zu groß (maximal 20 MB erlaubt).';
			case -3:
				return 'Nur Bilddateien (JPG, PNG, GIF, WEBP) und PDF sind erlaubt. Der Dateiinhalt muss dabei zur Dateiendung passen.';
			default:
				return 'Fehler beim Hochladen der Datei.';
		}
	}

	function insertFileLink(fileName, displayName) {
		const url = 'Backend/download.php?file=' + fileName + '&name=' + encodeURIComponent(displayName);
		const link = '[url=' + url + ']' + displayName + '[/url]';
		const curPos = x.waf[wafId].elements[postingId].reference.current.selectionStart;
		const curVal = x.waf.get(wafId, postingId);
		const leftValue = curVal.substring(0, curPos);
		const rightValue = curVal.substring(curPos);
		x.waf.set(wafId, postingId, leftValue + link + rightValue);
		x.waf.focus(wafId, postingId);
	}

	// Fuer Fett/Kursiv/Unterstrichen soll der eigentliche Dialog gar nicht erst
	// erscheinen, wenn im Beitragsfeld bereits Text markiert ist - dann direkt
	// die Markierung mit dem BBCode-Tag umschliessen (Wunsch mehrerer
	// Mitglieder, die den Dialog fuer diesen Fall als unnoetigen Umweg
	// empfanden). Ohne Markierung bleibt der Dialog wie gehabt bestehen, da
	// dort ja der einzufuegende Text erst eingegeben werden muss.
	function insertText(wafId, tag) {
		const textarea = x.waf[wafId].elements[postingId].reference.current;
		const selectionStart = textarea.selectionStart;
		const selectionEnd = textarea.selectionEnd;
		if (['b', 'u', 'i'].includes(tag) && selectionStart !== selectionEnd) {
			wrapSelection(wafId, tag, selectionStart, selectionEnd);
			return;
		}
		const dialogId = props.moduleId + '-add-text-' + tag;
		x.wad[dialogId].wafId = wafId;
		x.wad[dialogId].show(() => { x.waf.focus(dialogId, 'text') });
	}

	function wrapSelection(wafId, tag, selectionStart, selectionEnd) {
		const curVal = x.waf.get(wafId, postingId);
		const leftValue = curVal.substring(0, selectionStart);
		const selectedValue = curVal.substring(selectionStart, selectionEnd);
		const rightValue = curVal.substring(selectionEnd);
		const newText = leftValue + '[' + tag + ']' + selectedValue + '[/' + tag + ']' + rightValue;
		x.waf.set(wafId, postingId, newText);
		x.waf.focus(wafId, postingId);
		x.waf.setCursorPos(wafId, postingId, selectionStart, selectionStart + tag.length + 2 + selectedValue.length + tag.length + 3);
		x.wau.postingBackup(wafId, props.answerTo, newText);
	}

	function reset() {
		x.waf.set(wafId, postingId, '');
		x.wau.postingBackupRemove(wafId, props.answerTo);
	}

	function preview(result) {
		// console.log(result.data.content.posting);
		const previewDialog = props.id + '-preview';
		x.waf.set(previewDialog, 'preview-posting', x.wau.translatePosting(x.waf.get(wafId, postingId)));
		x.wad[previewDialog].show();
	}

	function makeSmilies(filter) {
		// Volltreffer (Schluessel === Filter) zuerst, statt in der sonst beliebigen
		// Reihenfolge der x.was.smilies-Definition irgendwo dazwischen/danach zu
		// erscheinen - bei getipptem Filter ist der exakte Treffer meist genau der
		// gesuchte Smiley.
		const matches = Object.entries(x.was.smilies).filter(([key]) => filter.length === 0 || key.includes(filter));
		matches.sort(([keyA], [keyB]) => (keyA === filter ? -1 : 0) - (keyB === filter ? -1 : 0));
		const smileyTags = matches.map(([key, value]) =>
			<i
				key={key}
				tabIndex="0"
				className="smiley select-smiley "
				dangerouslySetInnerHTML={{ __html: value }}
				title={key}
				alt={key}
				onClick={(e) => insertSmiley(e, key)}
				onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') insertSmiley(e, key); }}
			/>);

		return (
			<div>
				{smileyTags}
			</div>
		)
	}

	function showSmilies(e, target) {
		x.waf[wafId].smileyTarget = target;
		x.waf[wafId][smiliesId].show(e, true)
	}

	const postingToolbar = <React.Fragment>
		<i id="iconShowSmilies" className={`bi bi-emoji-smile context-menu-icon`} title="Smilies" onClick={(e) => showSmilies(e, 'posting')}></i>
		<i className={`bi bi-type-bold context-menu-icon`} title="Fett" onClick={() => insertText(wafId, 'b')}></i>
		<i className={`bi bi-type-underline context-menu-icon`} title="Unterstrichen" onClick={() => insertText(wafId, 'u')}></i>
		<i className={`bi bi-type-italic context-menu-icon`} title="Kursiv" onClick={() => insertText(wafId, 'i')}></i>
		<i className={`bi bi-link context-menu-icon`} title="Link mit Titel einfügen" onClick={() => insertLink(wafId)}></i>
		<i className={`bi bi-list-ul context-menu-icon`} title="Liste einfügen" onClick={() => insertList(wafId)}></i>
		<i className={`bi bi-quote context-menu-icon`} title="Zitat einfügen" onClick={() => insertText(wafId, 'quote')}></i>
		<i className={`bi bi-paperclip context-menu-icon`} title="Datei anhängen" onClick={() => selectFile()}></i>

	</React.Fragment>

	const buttons = [];
	buttons.push(<FormElement
		key={resetId}
		type="button"
		x={x}
		wafId={wafId}
		id={resetId}
		className="btn "
		onClick={reset}
		title="Leeren"
	/>);
	buttons.push(<FormElement
		key={previewId}
		type="button"
		x={x}
		wafId={wafId}
		id={previewId}
		className="btn "
		onClick={preview}
		title="Vorschau"
	/>);

	return (
		<React.Fragment>
			<input
				type="file"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={uploadFile}
			/>
			<div key={props.id + "-new-posting"} className="div-new-posting">
				{props.children}
				<Form
					key={props.id + "form-new-posting"}  
					id={formId}
					x={x}
					wafId={wafId}
					dialogId={props.dialogId}
					sendButtonTitle="Senden"
					addUrl={'forumId=' + props.forumId}
					module="Posting"
					sendTask="SaveNewPosting"
					classes="form-new-posting"
					buttons={buttons}
					onFormChanged={() => {
						if (x.waf.get(wafId, postingId) !== '') {
							x.waf.enable(wafId, previewId);
						}
						else {
							x.waf.disable(wafId, previewId);
						}
					}}
				>

					<div className="new-posting-textarea">
						<FormElement
							key={props.id + "-new-posting-textarea"} 
							type="textarea"
							x={x}
							dialogId={props.dialogId}
							wafId={wafId}
							id={postingId}
							mandatory={true}
							onPaste={checkPaste}
							toolBar={postingToolbar}
							title={(props.answerTo === 0) ? props.titleText : "Ihre Antwort:"}
							fieldValue=""
							rows="8"
							onChange={(event) => {
								x.wau.postingBackup(wafId, props.answerTo, event.target.value);
								emitTyping();
								handleColonTrigger(event.target.value);
							}}
						/>
						<DialogTable 
							id={props.id + '-table'}
							ref={memberRef}
							showFilter = "1"
							autoShow="0"
							getRows={getMentionMembersData}
							newRecordTitle="Neues Mitglied"
							onCancel={() => {
								console.log('cancel...');
								x.waf.insertText(wafId, postingId, '@');
							}}
							onSelect={(memberSelected) => {
								console.log(memberSelected);
								x.waf.insertText(wafId, postingId, '@' + memberSelected.name + ' ');
							}}
							onAfterRender={(visible) => {
								console.log(visible);
								if (!visible) {
									x.waf.focus(wafId, postingId);
								}
							}}
							onInsert={() => {
								return false;
							}}
						/>
						<DialogSelectText
							key={props.id + "-dialog-select-text"} 
							id={selectMemberId}
							moduleId={props.moduleId}
							x={x}
							onSetData={x.wau.setMembersData}
							classes="dialog-select-member-mention"
							title="Mitglieder"
						/>

					</div>
				</Form>
			</div>
			<FormSelectImage
				key={props.id + "-form-select-image"} 
				id={smiliesId}
				componentId={x.wau.getComponentId()}
				textMode={false}
				x={x}
				moduleId={props.moduleId}
				callId="iconShowSmilies"
				wafId={wafId}
				classes="select-smilies"
				title="Smilies"
				alwayShowSelection={true}
				makeContent={makeSmilies}
				externalFilter={colonFilter}
				autoFocus={true}
			/>
			<DialogPreview
				key={props.id + "-preview"} 
				id={props.id + '-preview'}
				x={x}
				wafId={wafId}
				title="Vorschau"
				onSubmit={
					(e) => {
						if (x.waf.get(wafId, postingId) !== '') {
							x.waf[wafId].ok(e)
							x.wad[props.id + '-preview'].hide();
						}
						else {
							e.preventDefault();
							x.wah.addHint('Leere Nachricht, senden nicht möglich.', true);
						}
					}
				}
			/>
			<Dialog id={fileRenameId} x={x} title="Dateiname" classes="dialog-file-rename">
				<Form
					x={x}
					wafId={fileRenameId}
					enableSendButton={true}
					sendButtonTitle="Datei hochladen"
					onSubmit={confirmFileUpload}
					focusElement="filename"
					classes="form-file-rename"
					checkChanged={() => { return true; }}
				>
					<FormElement
						type="text"
						x={x}
						wafId={fileRenameId}
						id="filename"
						mandatory={true}
						title="Dateiname"
						fieldValue=""
						maxLength="150"
					/>
				</Form>
			</Dialog>
		</React.Fragment>
	);
}
